import { Container, Box, Typography, Button } from '@mui/material';
import { Add as AddIcon, Science as ScienceIcon, HelpOutline as HelpIcon } from '@mui/icons-material';
import { useStartMeasurement } from '@/features/measurement/hooks/useStartMeasurement';

export function DashboardEmptyState() {
  const { startMeasurement } = useStartMeasurement();

  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <ScienceIcon sx={{ fontSize: 100, color: 'primary.main', mb: 3 }} />

      <Typography variant="h4" gutterBottom>
        Welcome to Ediphor LabCloud
      </Typography>

      <Typography variant="body1" color="text.secondary" paragraph>
        You haven't created any tests yet. Let's get started with your first measurement.
      </Typography>

      <Button
        variant="contained"
        size="large"
        startIcon={<AddIcon />}
        onClick={startMeasurement}
        sx={{ mt: 2 }}
      >
        Create Your First Test
      </Button>

      <Box mt={4}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Need help getting started?
        </Typography>
        <Button
          variant="outlined"
          size="small"
          startIcon={<HelpIcon />}
          onClick={() => window.open('/docs/quick-start', '_blank')}
        >
          View Quick Start Guide
        </Button>
      </Box>
    </Container>
  );
}
